import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PamDialogComponent } from './pam-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PamDialogService {
  private readonly dialogService = inject(MatDialog);
  private dialogRef: MatDialogRef<PamDialogComponent> = null;

  public openDialog(partnerId?: string, accountGroupId?: string) {
    if (this.dialogRef) {
      return this.dialogRef;
    }

    this.dialogRef = this.dialogService.open(PamDialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        partnerId,
        accountGroupId,
      },
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });

    return this.dialogRef;
  }
}
